import actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = () => ({
  getNews: { data: null, loading: null, error: null }
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
